import makeStyles from '@material-ui/core/styles/makeStyles';
import { ButtonProps } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import React from 'react';

const useDangerButtonStyles = makeStyles((theme) => ({
  core: {
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
  },
}));

export function DangerButton(props: ButtonProps) {
  const classes = useDangerButtonStyles();

  return (
    <Button
      className={classes.core} size="small" variant="outlined"
      {...props}
    >
      {props.children}
    </Button>
  );
}
